module.exports = __webpack_public_path__ + "img/mal.630fec51.png";